import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'cliente-info-popup',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './cliente-info-popup.component.html',
  styleUrl: './cliente-info-popup.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClienteInfoPopupComponent {
  @Input() cliente: any;
  @Input() position: { top: string, left: string };
  ngOnInit(){
  }
 }
